<template>
    <Modal :width="width" @close="closeNewsletter" class="newsletter-modal" closeOnEscape dismissible hide-footer>
        <slot>
            <Newsletter />
        </slot>

        <button v-if="showClose" class="newsletter-modal__close" :title="$t('Generic.close')" @click="closeNewsletter">
            <IconSvg filepath="close.svg" />
        </button>
    </Modal>
</template>

<script>
import Newsletter from '@/components/newsletter/Newsletter';
import Modal from '@/components/Modal';

export default {
    name: 'NewsletterModal',
    data() {
        return {
            showModal: false
        };
    },
    props: {
        showClose: Boolean,
        width: {
            type: Number,
            default: 690
        }
    },
    components: {
        Newsletter,
        Modal
    },
    methods: {
        closeNewsletter() {
            this.$emit('close:newsletter');
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/mixins';

$padding: 20px;

.newsletter-modal {
    background-color: rgba(0, 0, 0, 0.5);

    ::v-deep .modal-wrapper {
        margin-top: 100px;

        @include mixins.mobile-only {
            max-width: calc(90% + 2 * #{$padding});
            margin-top: 1.75rem;
        }

        .modal-container {
            padding: $padding !important;
            background-color: transparent !important;
            box-shadow: none !important;

            .modal-body {
                padding: 0 !important;
                overflow: visible !important;
                box-shadow: 0 5px 15px rgba(variables.$black, 0.5);

                .discount-badge {
                    margin-left: -$padding !important;
                    top: -$padding;
                }

                .newsletter-body {
                    background-color: var(--footer-bg-color-opaque);
                }
            }
        }

        .newsletter {
            margin: 0;
        }
    }

    &__close {
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
        width: 31px;
        height: 30px;
        display: flex;
        border: none;
        justify-content: center;
        align-items: center;
        background-color: hsla(0, 0%, 0%, 0.75);
        color: variables.$muted;
        box-shadow: 5px 5px 10px 0 hsla(0, 0%, 0%, 0.25);
        z-index: 3;
        padding: 0;
    }
}
</style>
